import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const sumPageMeasurements = (assemblyData) => {
  if (!assemblyData || assemblyData.length === 0) return [];

  return assemblyData
    .map((asm) => {
      const pageMeasurements = asm.pageMeasurements || {};
      let totalNumeric = 0;
      let totalShapes = 0;
      let unit = '';

      for (const key of Object.keys(pageMeasurements)) {
        const pm = pageMeasurements[key];
        if (pm) {
          totalShapes += pm.shapeCount || 0;
          if (!unit && pm.unit) unit = pm.unit;
          const numeric = parseFloat(String(pm.displayValue || '').replace(/,/g, ''));
          if (!Number.isNaN(numeric)) totalNumeric += numeric;
        }
      }

      return { name: asm.name, totalNumeric, totalShapes, unit, color: asm.params?.Color ?? null };
    })
    .filter((t) => t.totalShapes > 0)
    .sort((a, b) => b.totalNumeric - a.totalNumeric);
};

const formatTotal = (value) => {
  if (value == null || value === 0) return '0';
  return String(Math.round(value));
};

const AssemblyTotalsWidget = ({ assemblyData, loading }) => {
  const { t } = useTranslation();
  const totals = useMemo(() => sumPageMeasurements(assemblyData), [assemblyData]);

  if (loading) {
    return (
      <div className="glass metric-card">
        <h5>{t('home.assembly_totals_title')}</h5>
        <div className="placeholder-line" style={{ height: '0.5rem', width: '60%', marginBottom: '0.75rem' }} />
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="placeholder-line"
            style={{ height: '0.7rem', width: `${90 - i * 10}%`, marginBottom: '0.5rem' }}
          />
        ))}
      </div>
    );
  }

  if (totals.length === 0) return null;

  return (
    <div className="glass metric-card">
      <h5>{t('home.assembly_totals_title')}</h5>
      <ul className="home-pages-list-measurements">
        {totals.map((total) => (
          <li
            key={total.name}
            className="home-pages-list-measurement-item"
            style={total.color ? { borderLeft: `4px solid ${total.color}` } : undefined}
          >
            <span className="home-pages-list-asm-name">
              {total.name}
            </span>
            <span className="home-pages-list-measurement-detail">
              {total.totalNumeric > 0 && <span className="home-assembly-value">{formatTotal(total.totalNumeric)}</span>}
              {total.totalNumeric > 0 && total.unit && <span className="home-assembly-unit"> {total.unit}</span>}
              <span className="home-pages-list-shape-count">{t('home.assembly_totals_shapes', { count: total.totalShapes })}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AssemblyTotalsWidget;
